



































import { Vue } from "vue-property-decorator";
import type { pagination } from "@/@types/base"
import Pagination from "@/components/Table/Pagination.vue"

export default Vue.extend({
  name : "BasicTable",
  components: { Pagination },
  props: {
    index   : { type: Number, default: 0 },         // 第几个 Table
    primary : { type: String, default: "id" },
    api     : { type: String, required: true },     // 接口地址
    keywords: { type: Object },
    size    : { type: String, default: "middle" },   // Table 大小
    columns : { required: true },                   // 单元格配置
    loading : { type: Boolean, default: false },    // 列表加载状态
  },
  data() {
    return {
      list      : [],
      scroll    : {},
      total     : 0,
      pagination: {
        current: 1,
        size   : 10,
      } as pagination,
    }
  },
  methods: {
    Change(e: any) {
      console.log("Change:", e)
    },
    async Search() {
      const res = await this.$store.dispatch(this.api, this.keywords);
      if (res.Code == 200) {
        this.list  = res.Data.data
        this.total = res.Data.total
      }
    },
    RowEvent(record: any) {
      return {
        onClick: (event: any) => {
          console.log("Event: row-click ", event)
          this.$emit("row-click", record)
        },
        onDblclick: (event: any) => {
          console.log("Event: row-dbclick ", event)
          this.$emit("row-dbclick", record)
        }
      }
    }
  }
})
